import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Quote } from "lucide-react";
import api from "@/lib/api";

export const ReviewHighlights = () => {
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    api.get("/reviews/highlights").then((r) => setReviews(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (reviews.length < 2) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % reviews.length), 6000);
    return () => clearInterval(t);
  }, [reviews]);

  if (!reviews.length) return null;
  const r = reviews[index];

  return (
    <section className="border-y border-border/60 bg-card/20" data-testid="review-highlights">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16 text-center">
        <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-8">What seekers are saying</p>
        <div key={index} className="animate-in fade-in slide-in-from-bottom-2 duration-700">
          <Quote size={20} className="mx-auto text-primary mb-5" />
          <blockquote className="font-display text-2xl sm:text-3xl text-foreground leading-snug max-w-2xl mx-auto" data-testid="review-highlight-quote">
            “{r.comment}”
          </blockquote>
          <p className="text-sm text-muted-foreground mt-6" data-testid="review-highlight-attribution">
            — {r.seeker_name}, on{" "}
            <button onClick={() => navigate(`/practitioner/${r.practitioner_id}`)}
              className="cream-link" data-testid="review-highlight-practitioner-link">{r.business_name}</button>
          </p>
        </div>
        {reviews.length > 1 && (
          <div className="flex items-center justify-center gap-2 mt-8" data-testid="review-highlight-dots">
            {reviews.map((_, i) => (
              <button key={i} onClick={() => setIndex(i)} aria-label={`Review ${i + 1}`}
                data-testid={`review-dot-${i}`}
                className={`h-1.5 rounded-full transition-all duration-300 ${i === index ? "w-6 bg-primary" : "w-1.5 bg-border hover:bg-muted-foreground"}`} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
